import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12 20L20 12M20 12L12 4M20 12L4 12",
  stroke: "currentColor",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }